import React from 'react';
import lockIcon from '../../ASUPhotos/icons/me3_SSO_Lock.svg'
import classNames from 'classnames';

const LockIcon = ({ propsClassName }) => {
  return (
    <img className={classNames({
    'lock-icon': true,
    [propsClassName]: propsClassName,
    })}
      src={lockIcon}
      alt="lock"
      tabIndex="0"
      role="button"
      aria-label="view password button"
    />
  );
};

export default LockIcon;